import { MaxUint256 } from '@ethersproject/constants'

export const MAX_APPROVE_AMOUNT = MaxUint256.toBigInt()
